module.exports = __webpack_public_path__ + "img/yj_recall_fu.ac2821d2.png";